import { useState, useMemo, use, createContext, JSX, FC } from 'react';
import type { ContentType } from './mobile/MobileMenu.tsx';

const withExampleProvider =
  <P extends object>(Component: () => JSX.Element): FC<P> =>
  (props: P) => {
    const [type, setType] = useState(defType);

    const value = useMemo(
      () => ({
        type,
        setType,
      }),
      [type]
    );

    return (
      <GamePageContent value={value}>
        <Component {...props} />
      </GamePageContent>
    );
  };

const defType: ContentType = 'live';

const GamePageContent = createContext<{
  type: ContentType;
  setType: (type: ContentType) => void;
}>({
  type: defType,
  setType: () => {},
});

export const useGamePageContent = () => use(GamePageContent);

export { withExampleProvider };
